<template>
<div class="w-full">
  <div class="flex flex-wrap w-full" style="margin:10px;">
    <div class="vx-col  w-full" style="margin:10px;">
      <div class="vx-row justify-center" v-if="activeQuestion.id != -1">
        <chevron-left-icon @click="previous()" size="2.0x" class="custom-class cursor-pointer" style="color:#1d9cd3;"></chevron-left-icon>
        <span class="text-center " style="vertical-align:middle; color:#1d9cd3; font-size:20px;"><strong> {{getIndex}} 문제- ID:{{data_local.id}} </strong></span>
        <chevron-right-icon @click="next()" size="2.0x" class="custom-class cursor-pointer" style="color:#1d9cd3;"></chevron-right-icon>
      </div>
      <div class="vx-row justify-center" v-if="activeQuestion.id == -1">
        <span class="text-center " style="vertical-align:middle; color:#1d9cd3; font-size:20px;"><strong> 문제가 없습니다. 상단 버튼을 눌러 생성 해보세요 </strong></span>
      </div>
    </div>
    <div v-if="activeQuestion.id != -1" class="w-full">
      <transition name="zoom-out">
        <div class=" w-full" v-if="activePage" v-show="activePage">
          <div class="vx-col  w-full" style="margin:10px;">
            <vx-card>
              <div class="vx-col w-full">
                <div class="mt-8 flex flex-wrap items-center justify-end" v-if="AppActiveUser.userRole == 'admin' && !data_local.defect">
                  <vs-button color="primary" style="color:#1d9cd3; margin-right:3px; justify-end;" type="border" icon-pack="feather" size="small" icon="icon-save" @click="saveQuestion()">저장</vs-button>
                  <vs-button class="flex items-center" color="danger" type="flat" icon="icon-trash" icon-pack="feather" @click="deleteQuestion()">삭제</vs-button>
                </div>
                <div class="mt-8 flex flex-wrap items-center justify-end" v-if="AppActiveUser.userRole == 'admin' && data_local.defect">
                  <vs-button color="warning" style="color:warning; margin-right:3px; justify-end;" type="border" icon-pack="feather" size="small" icon="icon-save" @click="saveQuestion()">수정</vs-button>
                  <vs-button class="flex items-center" color="danger" type="flat" icon="icon-trash" icon-pack="feather" @click="deleteQuestion()">삭제</vs-button>
                </div>
              </div>
              <div class="vx-row">
                <!-- Address Col -->
                <div class="vx-col w-full" style="display: flex; justify-content: space-between; align-items: center;">
                  <!-- this.data_local -->
                  <div style="display: flex;">
                    <div class="" style="padding-right: 40px; text-align: center;">
                      <div style="font-size: 16px; font-weight: 600;">문제 형식</div>
                      <div style="margin-top: 8px;">
                        <span v-if="questionType == 1">객관식</span>
                        <span v-if="questionType == 2">주관식</span>
                        <span v-if="questionType == 3">복수 선택 객관식</span>
                        <span v-if="questionType == 4">듣기평가</span>
                      </div>
                    </div>
                    <div class="" style="padding-right: 40px; text-align: center;">
                      <div style="font-size: 16px; font-weight: 600;">배점</div>
                      <div style="margin-top: 8px;">{{ data_local.score }}점</div>
                    </div>
                    <div class="" style="padding-right: 40px;">
                      <div style="font-size: 16px; font-weight: 600;">문제 유형</div>
                      <div style="display: flex; align-items: center;">
                        <div v-if="subjectNum == 9">
                          <!-- 지구과학1, 2 예외처리 지1==13, 지2==16 -->
                          <div v-if="subjectDetailNum == 13 || subjectDetailNum == 16">
                            <vs-select class="selectPracticeType2" v-model="select1">
                              <vs-select-item v-if="(item.subject_type_id == subjectNum && (item.subject_detail_type_id == 13 || item.subject_detail_type_id == 16)) || item.subject_type_id == -1" :key="index" :value="item.id" :text="item.name" v-for="(item, index) in categoryList" />
                            </vs-select>
                          </div>
                          <!-- 물리1 예외처리 물1==10, 물2==14 -->
                          <div v-else-if="subjectDetailNum == 10">
                            <vs-select class="selectPracticeType2" v-model="select1">
                              <vs-select-item v-if="(item.subject_type_id == subjectNum && (item.subject_detail_type_id == 10 || item.subject_detail_type_id == 14)) || item.subject_type_id == -1" :key="index" :value="item.id" :text="item.name" v-for="(item, index) in categoryList" />
                            </vs-select>
                          </div>
                          <div v-else>
                            <vs-select class="selectPracticeType2" v-model="select1">
                              <vs-select-item v-if="(item.subject_type_id == subjectNum && item.subject_detail_type_id == subjectDetailNum) || item.subject_type_id == -1" :key="index" :value="item.id" :text="item.name" v-for="(item, index) in categoryList" />
                            </vs-select>
                          </div>
                        </div>
                        <div v-else>
                          <vs-select class="selectPracticeType2" v-model="select1">
                            <vs-select-item v-if="item.subject_type_id == subjectNum || item.subject_type_id == -1" :key="index" :value="item.id" :text="item.name" v-for="(item, index) in categoryList" />
                          </vs-select>
                        </div>
                        <vs-select v-if="checkSelect2 && categoryList[wrong_index].subject_id != 30" class="selectPracticeType2" v-model="select2" style="margin-left: 10px;">
                          <vs-select-item :key="index" :value="item" :text="item.name" v-for="(item, index) in filter_1(select1)" />
                        </vs-select>
                        <vs-select v-if="checkSelect3 && categoryList[wrong_index].subject_id != 30" class="selectPracticeType2" v-model="select3" style="margin-left: 10px;">
                          <vs-select-item :key="index" :value="item" :text="item.name" v-for="(item, index) in filter_2(select2)" />
                        </vs-select>
                      </div>
                    </div>
                    <div class="" style="padding-right: 40px;">
                      <div style="font-size: 16px; font-weight: 600;">난이도</div>
                      <vs-select style="width: 100px;" placeholder="선택" v-model="select4">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in options4" />
                      </vs-select>
                    </div>
                  </div>
                  <div>
                    <vs-button style="height: 40px; width: 70px; padding: 0; margin-right: 10px;" @click="goEdit()">EDIT</vs-button>
                    <vs-button style="height: 40px; width: 70px; padding: 0; margin-right: 20px;" @click="saveType()">저장</vs-button>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col  w-full " style="margin:10px;">
            <vx-card>
              <vs-button class="w-full" v-if="questionActive" @click="questionActive = false" style="margin-bottom:10px;">숨기기</vs-button>
              <vs-button class="w-full" v-if="questionActive == false" @click="questionActive = true" style="margin-bottom:10px;">문제 보이기</vs-button>
              <!-- <transition name="slide"> -->
              <div v-if="questionActive">
                <div style="margin:10px;">
                  <span><strong> 문제 </strong></span>
                  <div style="border:1px solid #ccc; padding: 10px; margin-top: 5px;" v-html="data_local.title"></div>
                </div>
                <div style="margin:10px;">
                  <span><strong> 문제 추가 정보 </strong></span>
                  <!-- <quill-editor v-model="data_local.question_info"></quill-editor> -->
                  <div style="border:1px solid #ccc; padding: 10px; margin-top: 5px;" v-html="data_local.question_info"></div>
                </div>
              </div>
              <!-- </transition> -->
            </vx-card>
          </div>
          <div class="vx-col  w-full " style="margin:10px;">
            <vx-card>
              <div v-if="data_local.question_type == 4">
                <div style="margin:10px; margin-top: 0;">
                  <div class="vx-row lg:w-full" style="flex-direction: column; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;" v-if="data_local.audio_file_name">
                    <div style="font-weight: bold; margin-bottom: 5px;">오디오 재생</div>
                    <audio ref="audioObj" controls controlsList="nodownload" @ended="audioEndEvent">
                      <source :src="audioUrl" type="audio/mp3" />
                    </audio>
                  </div>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col  w-full " style="margin:10px;">
            <vx-card>
              <vs-button class="w-full" v-if="solvingActive" @click="solvingActive = false" style="margin-bottom:10px;">숨기기</vs-button>
              <vs-button class="w-full" v-if="solvingActive == false" @click="solvingActive = true" style="margin-bottom:10px;">문제 풀이 보이기</vs-button>
              <div v-if="solvingActive">
                <div style="margin:10px; ">
                  <span><strong> 문제 풀이 </strong></span>
                  <div style="border:1px solid #ccc; padding: 10px; margin-top: 5px;" v-html="data_local.solving"></div>
                </div>
              </div>
            </vx-card>
          </div>
          <div class="vx-col  w-full" style="margin:10px;">
            <multiple-question v-if="data_local.question_type == 3" />
            <answer v-if="data_local.question_type == 2" />
            <number-question v-if="data_local.question_type == 1 || data_local.question_type == 4" />
          </div>
        </div>
      </transition>
    </div>
  </div>

  <vs-prompt class="email-compose" title="APP 확인" :buttons-hidden="true" :active.sync="showPrompt">
    <vs-tabs alignment="fixed">
      <vs-tab label="문제">
        <!-- <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
            <form @submit.prevent> -->
        <vx-card class="box1 p-4" style="width:480px;" v-if="data_local.question_type == 4" :is="scrollbarTag">
          <audio controls controlsList="nodownload">
            <source :src="audioUrl" type="audio/mp3" />
          </audio>
        </vx-card>
        <vx-card class="box1 p-4 scroll-area" style="width:480px; height:150px;" :is="scrollbarTag">
          <div class="output ql-snow">
            <div class="ql-editor h-full" v-html="data_local.title"></div>
          </div>
        </vx-card>
        <vx-card class="box1 p-4 scroll-area" style="width:480px; height:300px; shadow:5px;" :is="scrollbarTag" v-if="data_local.question_info">
          <div class="text-right">
            <vs-button @click="popupActive=true" class="round" color="#ccc" style="padding-left:15px; padding-right:15px; padding-top:3px; padding-bottom:3px;">전체보기</vs-button>
            <div class="output ql-snow" :is="scrollbarTag">
              <div class="ql-editor h-full" v-html="data_local.question_info"></div>
            </div>
          </div>
        </vx-card>
        <vx-card class="box1 p-4 scroll-area" style="width:480px;  height:200px;" :is="scrollbarTag" v-if="data_local.question_info">
          <MultipleView :activeQuestion="data_local" />
        </vx-card>
        <vx-card class="box1 p-4 scroll-area" style="width:480px;  height:500px;" :is="scrollbarTag" v-if="!data_local.question_info">
          <MultipleView :activeQuestion="data_local" />
        </vx-card>
        <!-- </form>
          </component> -->
      </vs-tab>
      <vs-tab label="해설">
        <vx-card class="box1 p-4 scroll-area" style="width:480px; height:650px;" :is="scrollbarTag">
          <div class="output ql-snow">
            <div class="ql-editor h-full" v-html="data_local.solving"></div>
          </div>
        </vx-card>
      </vs-tab>
    </vs-tabs>
  </vs-prompt>

  <vs-prompt class="email-compose" title="APP 보기" accept-text="업로드" cancel-text="취소" @cancel="clearFields" @close="clearFields" @accept="updateQuestion" :active.sync="activePrompt">
    <vs-tabs alignment="fixed">
      <vs-tab label="문제">
        <!-- <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
            <form @submit.prevent> -->
        <vx-card class="box1 p-4" style="width:480px;" v-if="data_local.question_type == 4" :is="scrollbarTag">
          <audio controls controlsList="nodownload">
            <source :src="audioUrl" type="audio/mp3" />
          </audio>
        </vx-card>
        <vx-card class="box1 p-4 scroll-area" style="width:480px; height:150px;" :is="scrollbarTag">
          <div class="output ql-snow">
            <div class="ql-editor h-full" v-html="data_local.title"></div>
          </div>
        </vx-card>
        <vx-card class="box1 p-4 scroll-area" style="width:480px; height:300px; shadow:5px;" :is="scrollbarTag" v-if="data_local.question_info">
          <div class="text-right">
            <vs-button @click="popupActive=true" class="round" color="#ccc" style="padding-left:15px; padding-right:15px; padding-top:3px; padding-bottom:3px;">전체보기</vs-button>
            <!-- <div style="height:300px; width:300px" v-html="data_local.question_info"></div> -->
            <!-- <quill-editor disable v-model="data_local.question_info"></quill-editor>s -->
            <div class="output ql-snow" :is="scrollbarTag">
              <div class="ql-editor h-full" v-html="data_local.question_info"></div>
            </div>
          </div>
        </vx-card>
        <vx-card class="box1 p-4 scroll-area" style="width:480px;  height:200px;" :is="scrollbarTag" v-if="data_local.question_info">
          <MultipleView :activeQuestion="data_local" />
        </vx-card>
        <vx-card class="box1 p-4 scroll-area" style="width:480px;  height:500px;" :is="scrollbarTag" v-if="!data_local.question_info">
          <MultipleView :activeQuestion="data_local" />
        </vx-card>
        <!-- </form>
          </component> -->
      </vs-tab>
      <vs-tab label="해설">
        <vx-card class="box1 p-4 scroll-area" style="width:480px; height:650px;" :is="scrollbarTag">
          <div class="output ql-snow">
            <div class="ql-editor h-full" v-html="data_local.solving"></div>
          </div>
        </vx-card>
      </vs-tab>
    </vs-tabs>
  </vs-prompt>

  <vs-popup class="holamundo" title="전체 보기" :active.sync="popupActive">
    <div class="output ql-snow">
      <div class="ql-editor h-full" v-html="data_local.question_info"></div>
    </div>
    <!-- {{data_local.question_info}} -->
  </vs-popup>
  <vs-prompt title="문제점 등록" accept-text="업로드" cancel-text="취소" @cancel="clearFields" @close="clearFields" @accept="updateDefectQuestion" :active.sync="uploadDefect">
    <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
      <vs-textarea class="w-full mt-4" label="문제 커멘트" v-model="defectText" />
      <!-- <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">문제점을 등록 하시나요? :)</label> -->
    </component>
  </vs-prompt>

  <vs-prompt title="파일 업로드" :buttons-hidden="true" :active.sync="uploadPrompt">
    <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
      <label for="inputFile" style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">파일 업로드 중입니다 - 조금만 기다려주세요 :)</label>
      <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
        <vs-progress indeterminate color="primary"></vs-progress>
      </div>
    </component>
  </vs-prompt>
</div>
</template>
<script>
import MultipleQuestion from './MultipleQuestion.vue'
import Answer from './Answer.vue'
import NumberQuestion from './NumberQuestion.vue'
import InputTag from 'vue-input-tag'
import MultipleView from './MultipleView.vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {
  ChevronLeftIcon
} from 'vue-feather-icons'
import {
  ChevronRightIcon
} from 'vue-feather-icons'
import {
  PlayIcon,
  PauseIcon
} from 'vue-feather-icons'

export default {
  name: "",
  data() {
    return {
      defectText: '',
      uploadDefect: false,
      showPrompt: false,
      content: '',
      sequence: false,
      audioUrl: '',
      audioFlag: false,
      uploadPrompt: false,
      questionType: 0,
      typeVal: [1, 2, 3, 4],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
      audioActive: false,
      solvingActive: false,
      questionActive: true,
      radios1: 0,
      popupActive: false,
      data_local: '',
      question_title: '',
      question_info: '',
      multiple_text: '',
      activePrompt: false,
      intervalObj: null,
      activePage: true,
      tags: [],
      audioFile: '',
      select1: null,
      select2: null,
      select3: null,
      select4: null,
      selectIndex1: null,
      selectIndex2: null,
      selectIndex3: null,
      options4: [
        { text: '하', value: 1},
        { text: '중', value: 2},
        { text: '상', value: 3}
      ],
      typeInfo: {
        id: 1,
        category_id: 1,
        main_category_id: 1,
        sub_category_id: 1,
        level: 1
      },
      subjectNum: null,
      subjectDetailNum: null,
      saveState: false,
      initFlag: true,
      checkSelect2: false,
      checkSelect3: false,
      wrong_index: null,
    }
  },
  components: {
    VuePerfectScrollbar,
    ChevronLeftIcon,
    ChevronRightIcon,
    MultipleQuestion,
    Answer,
    NumberQuestion,
    PlayIcon,
    PauseIcon,
    'input-tag': InputTag,
    'MultipleView': MultipleView
  },
  methods: {
    goEdit() {
      this.$router.push('/app/exam/edit-form')
    },
    audioEndEvent() {
      this.audioFlag = false
    },
    updatePracticeType() {
      this.$store.dispatch('etest/updatePracticeTypeInfo', this.typeInfo)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '저장 완료',
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    filter_1(val) {
      if (val) {
        if(this.mainCategoryList.filter(item => item.category_id == val).length){
          this.checkSelect2 = true
        }else{
          this.checkSelect2 = false
        }
        return this.mainCategoryList.filter(item => item.category_id == val)
      }
      else{
        return null
      }
    },
    filter_2(val) {
      if (val) {
        if(this.subCategoryList.filter(item => item.main_category_id == val.id).length){
          this.checkSelect3 = true
        }else{
          this.checkSelect3 = false
        }
        return this.subCategoryList.filter(item => item.main_category_id == val.id)
      }
      else{
        return null
      }
    },
    saveType() {
      this.typeInfo.id = this.activeQuestion.id
      this.typeInfo.category_id = this.select1
      if (this.select2) {
        this.typeInfo.main_category_id = this.select2.id
      } else {
        this.typeInfo.main_category_id = null
      }
      if (this.select3) {
        this.typeInfo.sub_category_id = this.select3.id
      } else {
        this.typeInfo.sub_category_id = null
      }
      this.typeInfo.level = this.select4
      this.updatePracticeType()
    },
    checkDefect() {
      this.uploadDefect = true
    },
    updateDefectQuestion() {
      this.data_local.command = this.defectText

      this.$store.dispatch('etest/updateDefect', {
        id: this.data_local.id,
        command: this.defectText
      }).then(() => {
        this.$vs.notify({
          title: '성공',
          color: 'success'
        })
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    },
    updateAudioFile() {
      this.uploadPrompt = true
      this.audioFile = document.getElementById("inputFile").files[0]
      this.data_local.audio_file_name = this.audioFile.name
      this.$store.dispatch('etest/updateAudioFile', {
        param: {
          id: this.data_local.id
        },
        file: this.audioFile
      }).then(() => {
        this.uploadPrompt = false
        this.$vs.notify({
          color: 'success',
          title: '파일 저장 완료',
        })
      }).catch(() => {
        this.uploadPrompt = false
        this.data_local.audio_file_name = ''
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    },
    updateQuestion() {
      if (this.sequence == true) {
        this.data_local.sequence = this.getIndex
      }
      if (this.data_local.defect && this.AppActiveUser.userRole == 'admin') {
        this.$store.dispatch('etest/updateDefectQuestion', this.data_local)
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: '저장 완료',
            })
          }).catch(() => {
            this.$vs.notify({
              color: 'danger',
              title: '실패',
              text: '관리자에게 문의 부탁 드립니다.'
            })
          })
      } else {
        this.$store.dispatch('etest/updateEtestQuestion', this.data_local)
          .then(() => {
            this.$vs.notify({
              color: 'success',
              title: '저장 완료',
            })
          }).catch(() => {
            this.$vs.notify({
              color: 'danger',
              title: '실패',
              text: '관리자에게 문의 부탁 드립니다.'
            })
          })
      }
    },
    showQuestion() {
      this.data_local.answer = this.activeQuestion.answer
      this.data_local.ex_answer = this.activeQuestion.ex_answer
      this.data_local.answer_multiple = this.activeQuestion.answer_multiple
      this.data_local.answer_number = this.activeQuestion.answer_number

      if (this.data_local.question_type == 4) {
        var token = ''
        if (localStorage.getItem("filleduToken")) {
          token = localStorage.getItem("filleduToken")
        } else if (sessionStorage.getItem("filleduToken")) {
          token = sessionStorage.getItem("filleduToken")
        }
        this.audioUrl = this.$store.state.baseURL + "/streaming/audio/question/id=" + this.data_local.id + "&token=" + token
      }
      this.showPrompt = true
    },
    saveQuestion() {
      this.data_local.answer = this.activeQuestion.answer
      this.data_local.ex_answer = this.activeQuestion.ex_answer
      this.data_local.answer_multiple = this.activeQuestion.answer_multiple
      this.data_local.answer_number = this.activeQuestion.answer_number

      if (this.data_local.question_type == 4) {
        var token = ''
        if (localStorage.getItem("filleduToken")) {
          token = localStorage.getItem("filleduToken")
        } else if (sessionStorage.getItem("filleduToken")) {
          token = sessionStorage.getItem("filleduToken")
        }
        this.audioUrl = this.$store.state.baseURL + "/streaming/audio/question/id=" + this.data_local.id + "&token=" + token
      }
      this.activePrompt = true
    },
    previous() {
      const index = this.questionList.findIndex((item) => item.id == this.activeQuestion.id) - 1
      if (index != -1) {
        this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[index])
      } else {
        this.$vs.notify({
          color: 'danger',
          title: '첫번째 문제 입니다.',
        })
      }

      var token = ''
      if (localStorage.getItem("filleduToken")) {
        token = localStorage.getItem("filleduToken")
      } else if (sessionStorage.getItem("filleduToken")) {
        token = sessionStorage.getItem("filleduToken")
      }
      this.audioUrl = this.$store.state.baseURL + "/streaming/audio/question/id=" + this.data_local.id + "&token=" + token
    },
    next() {
      const index = this.questionList.findIndex((item) => item.id == this.activeQuestion.id) + 1
      if (index < this.questionList.length) {
        this.$store.commit('etest/ACTIVE_QUESTION', this.questionList[index])
      } else {
        this.$vs.notify({
          color: 'danger',
          title: '마지막 문제 입니다.',
        })
      }
    },
    deleteQuestion() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.getIndex + '번째 문제 삭제',
        text: '정말 삭제하시겠습니까? 작성된 정보가 모두 삭제 됩니다. ',
        accept: this.accept
      })
    },
    accept() {
      this.$store.dispatch('etest/deleteQuestion', this.data_local.id)
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: '삭제 완료',
          })
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: '실패',
            text: '관리자에게 문의 부탁 드립니다.'
          })
        })
    },
    clearFields() {
      this.$nextTick(() => {
        this.defectText = ''
      })
    },
    init() {
      this.initFlag = true
      if (this.activeQuestion.category_id) {
        this.select1 = this.activeQuestion.category_id
        this.wrong_index = this.categoryList.findIndex((item) => {
          return item.id == this.select1
        })
        this.checkSelect2 = true
      }
      if (this.activeQuestion.main_category_id) {
        var index1 =this.mainCategoryList.findIndex((item) => {
          return item.id == this.activeQuestion.main_category_id
        })
        this.select2 = this.mainCategoryList[index1]
        this.checkSelect3 = true
      }
      if (this.activeQuestion.sub_category_id) {
        var index2 =this.subCategoryList.findIndex((item) => {
          return item.id == this.activeQuestion.sub_category_id
        })
        this.select3 = this.subCategoryList[index2]
      }
      if (this.activeQuestion.level) {
        this.select4 = this.options4[this.activeQuestion.level - 1].value
      }
      this.data_local = JSON.parse(JSON.stringify(this.activeQuestion))
      this.defectText = this.data_local.command
      this.activePage = false
      this.questionType = this.data_local.question_type

      if (this.data_local.sequence == null || this.data_local.sequence == 0) {
        this.sequence = false
      } else {
        this.sequence = true
      }

      this.intervalObj = setInterval(() => {
        this.initFlag = false
        this.activePage = true
        clearInterval(this.intervalObj)
      }, 5)

    }
  },
  watch: {
    questionType() {
      if (this.questionType == 4) {
        this.sequence = true
      }
      this.data_local.question_type = this.questionType
    },
    activeQuestionId() {
      if (this.activeQuestionId == -1) {
        return
      }
      this.init()
      var token = ''
      if (localStorage.getItem("filleduToken")) {
        token = localStorage.getItem("filleduToken")
      } else if (sessionStorage.getItem("filleduToken")) {
        token = sessionStorage.getItem("filleduToken")
      }
      this.audioUrl = this.$store.state.baseURL + "/streaming/audio/question/id=" + this.data_local.id + "&token=" + token
    },
    select1() {
      if(this.initFlag){
        return
      }
      this.wrong_index = this.categoryList.findIndex((item) => {
        return item.id == this.select1
      })
      this.filter_1(this.select1)
      this.select2 = null
      this.select3 = null
      this.checkSelect3 = false
    },
    select2() {
      if(this.initFlag){
        return
      }
      this.filter_2(this.select2)
    },
    activeQuestion() {
      if (this.activeQuestion.category_id) {
        this.select1 = this.activeQuestion.category_id
        this.wrong_index = this.categoryList.findIndex((item) => {
          return item.id == this.select1
        })
      } else {
        this.select1 = null
      }
      if (this.activeQuestion.main_category_id) {
        var index1 =this.mainCategoryList.findIndex((item) => {
          return item.id == this.activeQuestion.main_category_id
        })
        this.select2 = this.mainCategoryList[index1]
      } else {
        this.checkSelect2 = false
        this.filter_1(this.select1)
        this.select2 = null
      }
      if (this.activeQuestion.sub_category_id) {
        var index2 =this.subCategoryList.findIndex((item) => {
          return item.id == this.activeQuestion.sub_category_id
        })
        this.select3 = this.subCategoryList[index2]
      } else {
        this.select3 = null
        this.checkSelect3 = false
      }
      if (this.activeQuestion.level) {
        this.select4 = this.options4[this.activeQuestion.level - 1].value
      } else {
        this.select4 = null
      }
    }
  },
  mounted() {

  },
  computed: {
    getIndex() {
      return this.questionList.findIndex((item) => item.id == this.activeQuestion.id) + 1
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag
    },
    activeQuestion() {
      return this.$store.state.etest.activeQuestion
    },
    activeQuestionId() {
      return this.$store.state.etest.activeQuestion.id
    },
    questionList() {
      return this.$store.state.etest.questionList
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser
    },
    categoryList() {
      return this.$store.state.etest.categoryList
    },
    mainCategoryList() {
      return this.$store.state.etest.mainCategoryList
    },
    subCategoryList() {
      return this.$store.state.etest.subCategoryList
    },
    getActiveSubject() {
      return this.$store.state.etest.activeSubject
    }
  },
  created() {
    this.init()
    this.subjectNum = this.getActiveSubject.subject_type_id
    this.subjectDetailNum = this.getActiveSubject.subject_detail_type_id
    if (this.subjectNum == 3 || this.subjectNum == 7 || this.subjectNum == 8) {
      this.subjectNum = 3
    }
    var token = ''
    if (localStorage.getItem("filleduToken")) {
      token = localStorage.getItem("filleduToken")
    } else if (sessionStorage.getItem("filleduToken")) {
      token = sessionStorage.getItem("filleduToken")
    }
    this.audioUrl = this.$store.state.baseURL + "/streaming/audio/question/id=" + this.data_local.id + "&token=" + token
  },

}
</script>
<style lang="scss" scoped>
</style>
